export default "__VITE_ASSET__D_snAr$r__"